@layer module {
.access-level-icon {
            display: inline-flex;
            flex-shrink: 0;
    }
} // layer module










@layer app {
.access-level-icon svg {
            width: $size-14;
            height: $size-14;
    }

.access-level-icon {
            color: var(--text-secondary);
    }
} // layer app










@layer context {
:global(.account-list__item.selected) .access-level-icon {
            color: var(--hero-text-soft);
    }

:global(.staff-account-card) .access-level-icon {
            color: var(--color-on-brand);
    }

:global(.staff-account-card) .access-level-icon svg {
            width: $size-18;
            height: $size-18;
    }
} // layer context
